import * as React from 'react';

import { cn } from '@/lib/utils';

export interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number;
}

function ProgressBar({ value, className, ...props }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div
      className={cn('relative h-5 w-full overflow-hidden rounded-full bg-muted', className)}
      {...props}
    >
      <div
        className="h-full rounded-full bg-primary transition-all duration-500 ease-out"
        style={{ width: `${clamped}%` }}
      />
      <span className="absolute inset-0 flex items-center justify-center text-xs font-medium text-foreground">
        {Math.round(clamped)}%
      </span>
    </div>
  );
}

export { ProgressBar };
